import dayjs from "dayjs";
import * as loginActions from '@login/ngrx/login.actions';
import * as mainActions from '@main/ngrx/actions/main.actions';
import * as associationsActions from '@clients/ngrx/actions/associations.actions';
import * as administratorsActions from '@references/ngrx/actions/administrators.actions';
import * as rolesActions from '@references/ngrx/actions/roles.actions';
import * as katottgActions from '@references/ngrx/actions/katottg.actions';
import * as erdpouActions from '@references/ngrx/actions/erdpou.actions';
import * as usersActions from '@clients/ngrx/actions/users.actions';
import * as requestsActions from '@support/ngrx/actions/requests.actions';
import * as contactsActions from '@crm/ngrx/actions/contacts.actions';
import * as leadsBoardActions from '@crm/ngrx/actions/leads-board.actions';
import * as leadsListActions from '@crm/ngrx/actions/leads-list.actions';
import * as crmSettingsActions from '@crm/ngrx/actions/settings.actions';

import {Component, OnDestroy, OnInit} from '@angular/core';
import {Router} from '@angular/router';
import {Reducers} from '@app/reducers';
import {dahPbx} from '@main/components/sip-dialog/sip-dialog.component';
import {Actions, ofType} from '@ngrx/effects';
import {Store} from '@ngrx/store';
import {TranslateService} from '@ngx-translate/core';
import {StompRService} from '@stomp/ng2-stompjs';
import {Subject, takeUntil} from 'rxjs';

@Component({
    selector: 'app-root',
    template: `
        <router-outlet></router-outlet>`,
    standalone: false
})
export class AppComponent implements OnInit, OnDestroy {
    title = 'dah-back-office';
    /** Subject to destroy Subscriptions */
    private destroyed$ = new Subject<void>();

    constructor(
        private translate: TranslateService,
        private actions$: Actions,
        private router: Router,
        private store$: Store<Reducers>,
        private stompRService: StompRService,
    ) {
        translate.setDefaultLang('ua');
        translate.addLangs(['en', 'ua', 'ru']);
        translate.use('ua');
    }

    ngOnInit() {
        this.watchLoginSuccess();
        this.watchLogout();
    }

    ngOnDestroy() {
        this.destroyed$.next();
        this.destroyed$.complete();
    }

    watchLoginSuccess() {
        this.actions$.pipe(
            ofType(loginActions.LoginActionTypes.LoginSuccess),
            takeUntil(this.destroyed$),
        ).subscribe((action: loginActions.LoginSuccess) => {
            const tokenExpires = action.payload.expiresIn ? (dayjs().unix() + action.payload.expiresIn).toString() : '';

            localStorage.setItem('token', action.payload.accessToken ? action.payload.accessToken : '');
            localStorage.setItem('refresh_token', action.payload.refreshToken ? action.payload.refreshToken : '');
            localStorage.setItem('tokenExpiresOn', tokenExpires);

            this.router.navigate(['/']);
        });
    }

    watchLogout() {
        this.actions$.pipe(
            ofType(loginActions.LoginActionTypes.LogOut),
            takeUntil(this.destroyed$),
        ).subscribe(() => {
            /** Set Initial States */
            this.store$.dispatch(new loginActions.SetInitialState());
            this.store$.dispatch(new mainActions.SetInitialState());
            this.store$.dispatch(new associationsActions.SetInitialState());
            this.store$.dispatch(new usersActions.SetInitialState());
            this.store$.dispatch(new contactsActions.SetInitialState());
            this.store$.dispatch(new leadsBoardActions.SetInitialState());
            this.store$.dispatch(new leadsListActions.SetInitialState());
            this.store$.dispatch(new crmSettingsActions.SetInitialState());
            this.store$.dispatch(new administratorsActions.SetInitialState());
            this.store$.dispatch(new rolesActions.SetInitialState());
            this.store$.dispatch(new katottgActions.SetInitialState());
            this.store$.dispatch(new erdpouActions.SetInitialState());
            this.store$.dispatch(new requestsActions.SetInitialState());
            /** Disconnect STOMP */
            if (this.stompRService) {
                this.stompRService.disconnect();
            }
            /** Disconnect SIP */
            if (dahPbx) {
                dahPbx.stop();
                dahPbx.unregister({all: true});
            }
            /** Clear Local Storage */
            localStorage.removeItem('token');
            localStorage.removeItem('refresh_token');
            localStorage.removeItem('tokenExpiresOn');
            localStorage.removeItem('appVersion');
            this.router.navigateByUrl('/login');
        });
    }
}
